<mic-modal #generalModal (result)="onModalClosed($event)"></mic-modal>

<ng-template hspModalContainer></ng-template>
